module.exports = __webpack_public_path__ + "static/media/bunny.a27820c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/bunny.mp4
// module id = 816
// module chunks = 1